import type { CurrencyInfo } from '@src/core/buyerApiClient';
import type { Order } from '@src/domains/orders/types/order';

export interface OrderPaymentSummary {
  /** `PaymentMethodCode` value the transaction was charged with. */
  methodCode: string;
  /** Card brand, lower-case. Null for methods without one, such as Pix. */
  brandCode: string | null;
  /** 1 for methods that do not support installments. */
  installments: number;
  installmentAmount: CurrencyInfo | null;
}

const splitAmount = (total: CurrencyInfo | undefined, installments: number): CurrencyInfo | null => {
  if (!total || installments < 1) {
    return null;
  }

  return {
    ...total,
    amountCents: Math.round(total.amountCents / installments),
    originalAmountCents: Math.round(total.originalAmountCents / installments),
  };
};

export const getOrderPaymentSummary = (order: Order | null | undefined): OrderPaymentSummary | null => {
  const transaction = order?.lastTransaction;

  if (!transaction) {
    return null;
  }

  return {
    methodCode: transaction.paymentMethod.code,
    brandCode: transaction.brand,
    installments: transaction.installments,
    installmentAmount: splitAmount(order?.finalAmountCurrencyInfo, transaction.installments),
  };
};
